import React, { useEffect } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Dialog, DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import Close from "@material-ui/icons/Close";

export default function ActiveDirectoryTable({
  action,
  variables,
  setOpen,
  setOpenVariable,
  setDictionaryTable,
  dictionaryTable,
  index,
  setIndex,
  inputName,
  titles = []
}) {

  // control of fields or set field
  useEffect(() => {
    if (action.fields[inputName]) {
      action.fields[inputName].type = "TABLE";
    }
    if (index !== -1) {
      action.fields.keyVariable.value =
        action.fields[inputName].value[index].key;
      action.fields.keyVariable.htmlValue =
        action.fields[inputName].value[index].key;

      action.fields.valueVariable.value =
        action.fields[inputName].value[index].value;
      action.fields.valueVariable.htmlValue =
        action.fields[inputName].value[index].value;
    } else {
      if (action.fields.keyVariable) {
        action.fields.keyVariable = { value: "", htmlValue: "" };
        action.fields.valueVariable = { value: "", htmlValue: "" };
      }
    }
  }, [index, action.fields, inputName]);

  // delete item in array
  function handleDelete() {
    dictionaryTable.splice(index, 1);
    setDictionaryTable(dictionaryTable);
    setOpen(false);
    setIndex(-1);
  }

  //update item in array
  function handleUpdate() {
    dictionaryTable[index].key = action.fields.keyVariable.value;

    dictionaryTable[index].value = action.fields.valueVariable.value;
    setOpen(false);
    setIndex(-1);
  }
  // added variable in array
  function handleAdd() {

    if (action.fields.keyVariable?.value) {
      setDictionaryTable((oldArr) => [
        ...oldArr,
        {
          key: action.fields.keyVariable?.value,
          value: action.fields.valueVariable?.value,
        },
      ]);
      setOpen(false);
      setIndex(-1);
    }
  }

  // select type


  // close modal
  function handleClose() {
    setOpen(false);
    setIndex(-1);
  }
  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      <DialogTitle id="alert-dialog-title">
        <div className="modal-title">
          Custom Attributes
          <Button data-test="cancelautom-button" onClick={handleClose}>
            <Close />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "400px" }}>
          <div className="form-element">
            {titles.length > 0 ? titles[0] : "User"}
            <TextInput
              action={action}
              inputName="keyVariable"
              isRequired={false}
              setOpenVariable={setOpenVariable}
              variables={variables}
            />
          </div>
          <div className="form-element">
            {titles.length > 0 ? titles[1] : "Distinguishedname"}
            <TextInput
              action={action}
              inputName="valueVariable"
              isRequired={false}
              setOpenVariable={setOpenVariable}
              variables={variables}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "space-between",
          padding: "8px 24px 16px 24px",
        }}
      >
        {index === -1 ? (
          <>
            <Button variant="outlined"
              style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="outlined"
              style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleAdd}>
              Add
            </Button>
          </>
        ) : (
          <>
            <Button variant="outlined"
              style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleDelete}>
              Delete
            </Button>
            <Button variant="outlined"
              style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleUpdate}>
              Edit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
